import axiosInstance from "../axiosInterceptor";

export async function checkToken() {
  const response = await axiosInstance.post(`student/checkToken`, {
    token: localStorage.getItem("token") ?? "",
  });
  const data = response?.data;
  const lastSixDigits = data?.data?.student_id.toString().slice(-6);
  localStorage.setItem("referralCode", lastSixDigits);
  // Store student MongoDB _id for use as senderId in chat
  if (data?.data?.student_id) {
    localStorage.setItem("studentId", data.data.student_id);
  }
  if (!response?.data.isSuccess) {
    localStorage.removeItem("token");
    localStorage.removeItem("questionId");
    localStorage.removeItem("serviceType");
  }
  return data;
}
